import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { PopOutProps } from "../../../utils/props";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

/** Grey DialogBackdrop overlay with a dialog container. Houses forms for sharing:
 * Books, Recipes, Invite(closed beta tester)
 *
 * Abstract to render Form request components - Component(child instead of prop), message
 *
 * [Share, RecipesList] -> PopOut -> Children
 */
function PopOut({
  isDialogOpen,
  onCloseDialog,
  children,
  message,
  onResetMessage,
}: PopOutProps) {

  /** Consolidations necessary closing actions across different rendered components
   * Close PopOut component while calling parent close logic
   * */
  function handleClose() {
    onCloseDialog();
    setTimeout(() => {
      onResetMessage();
    }, 310);
  }

  return (
    <Dialog open={isDialogOpen} onClose={handleClose} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 flex items-center ">
        <DialogPanel transition className="transform">
          <div className="fixed h-full inset-0 z-10 w-screen">
            <div className="flex h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <div
                id="alert-border-1"
                className="flex items-center p-4 mb-4 text-blue-800 border-t-4 border-blue-300 bg-blue-50 dark:text-blue-400 dark:bg-gray-800 dark:border-blue-800"
                role="alert"
              >
                {message ? message : children}
                <button
                  onClick={handleClose}
                  type="button"
                  className="ms-auto -mx-1.5 -my-1.5 bg-blue-50 text-blue-500 rounded-lg focus:ring-2 focus:ring-blue-400 p-1.5 hover:bg-blue-200 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:text-blue-400 dark:hover:bg-gray-700"
                  aria-label="Close"
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}

export default PopOut;
